import { makeStyles } from '@mui/styles';

import { TOAST_BOTTOM_VAR } from 'hooks/useToastsAbove';

const useStyles = makeStyles(() => ({
  snackbar: {
    maxWidth: 'calc(100vw - min(10%, 75px) - 32px)',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  },
  containerBottom: {
    bottom: `var(${TOAST_BOTTOM_VAR}, 14px) !important`,
    left: 'calc(min(10%, 75px) + 16px) !important',
    right: 'auto !important',
    maxWidth: 'calc(100vw - min(10%, 75px) - 32px) !important',
  },
}));

export default useStyles;
